<bl-page-card-container
  data-smartpresentation="container-pagina"
  backNavigation=".."
  id="resumo-guias-outras-ops"
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY"></ag-views-toolbar>
      <bl-competencia
        class="ml-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      <button
        class="p-button p-button-outlined p-button-icon-only ml-4"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-1">
    <ag-grid-angular
      #agGrid
      data-smartpresentation="ag-grid"
      class="ag-theme-balham w-full flex-1"
      [style.height]="gridHeight$ | async"
      [rowData]="rowData"
      [gridOptions]="gridOptions"
      [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
    >
    </ag-grid-angular>
  </div>
</bl-page-card-container>
